import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { Settings, Patient } from "../../../helpers/Contexts";
import * as API from "../../../api";

const HealthConditions = ({ defaultValue }) => {
  const settings = useContext(Settings);
  const patient = useContext(Patient);

  function handleConditions(e) {
    let healthConditionsArray = e.map((i) => i.label).filter((value, index, array) => array.indexOf(value) === index);
    let req = {
      patient: {
        id: patient.patientId,
        health_conditions: healthConditionsArray,
      },
    };
    API.postPatientConditions(req)
      .then((res) => console.log(res))
      .catch((err) => console.log(err));
  }

  return (
    <>
      <label>Health Conditions</label>
      <Select
        defaultValue={[...defaultValue]}
        isMulti
        name="health conitions"
        options={settings.health_conditions}
        onChange={(event) => handleConditions(event)}
        className="basic-multi-select"
        classNamePrefix="select"
      />
    </>
  );
};
export default HealthConditions;
